import React from "react";
import "./Hero.css";
import Button from "../../../components/Button/Button";
import profilePic from "../../../assests/images/profilePic.png";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="hero" id="Home">
      <img className="heroimg" src={profilePic} alt="animated photo of girl sitting at computer screen"></img>
      <div className="herotxt">
        <h1 className="hero-title">
          <span className="word"> Hi </span>
          <span className="word"> I'm </span>
          <span className="word altheader"> Allie</span>
        </h1>
        <p>
          I'm an Informatics student at Indiana University with a passion for
          technology and creative problem-solving. In my free time, I create
          projects like websites and serve as a UX design intern for the
          university. I like turning ideas into tangible results—and sometimes I
          even manage to make the process look effortless.
        </p>
        <div className="buttonHero">
          <Link to={"/projects/margham"}>
            <Button>Browse Projects</Button>
          </Link>

          <Link to={"/resume"}>
            <Button>My Resume</Button>
          </Link>
        </div>{" "}
      </div>
    </div>
  );
};

export default Hero;
